import type { VerticalModule } from '@lipaflow/shared'
import type { PortalContextResponse } from '@lipaflow/portal-core'
import { RENTAL_DEFAULT_CONTEXT } from './context/defaultContext'
import { CalledOffNotice } from './payer/CalledOffNotice'

/**
 * The rental vertical as a *payer* shell composes it (ADR-0004 §2).
 *
 * The tenant portal is money-only today: rent, receipts and plans all come
 * from `@lipaflow/portal-core`, so this module contributes the vertical's
 * labels, and one slot on the balance page: a home whose tenancy was called
 * off says so (QA23-2). Lease and maintenance pages belong to the operator
 * module -- mounting them here would put a managing agent's lease book in a
 * renter's portal.
 */
export const rentalModule: VerticalModule<PortalContextResponse> = {
  code: 'rental',
  defaultContext: RENTAL_DEFAULT_CONTEXT,
  slots: {
    portalAccountStatus: CalledOffNotice,
  },
}
